<template>
  <div class="">
    <mobile-portrait-dummy/>
    <Test/>
  </div>
</template>

<script>
import MobilePortraitDummy from '@/components/MobilePortraitDummy/MobilePortraitDummy'
import Test from '@/components/Test/Test'

export default {
  name: 'test',
  components: {
    MobilePortraitDummy,
    Test,
  },
}
</script>

<style scoped>

</style>
